import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const CreateUser = () => {
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();
  const [areas, setAreas] = useState([]);

  const [formData, setFormData] = useState({
    IdDocumento: "",
    type_doc: "",
    first_name: "",
    second_name: "",
    last_name: "",
    second_last_name: "",
    email: "",
    role: "",
    area: "",
    state: 1,
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // -------------------------------------------
    // 🔍 VALIDACIÓN GLOBAL (igual a Register.jsx)
    // -------------------------------------------
    const requiredFields = [
      "IdDocumento",
      "type_doc",
      "first_name",
      "last_name",
      "email",
      "role",
      "area"
    ];

    const emptyFields = requiredFields.filter(
      (field) => !formData[field] || formData[field].toString().trim() === ""
    );

    if (emptyFields.length > 0) {
      setError("Hay campos requeridos incompletos.");
      return;
    }
    // -------------------------------------------

    try {
      const res = await authFetch(ENDPOINTS.createUser, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      if (!res.success) {
        setError(res.message);
        return;
      }

      setSuccess("Usuario creado correctamente");
      setTimeout(() => navigate("/session/user/user"), 1500);
    } catch (err) {
      console.error(err);
      setError("Error en el servidor");
    }
  };

useEffect(() => {
  const fetchAreas = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getarea, {
        method: "GET"
      });

      if (res.success) {
        setAreas(res.data);
      } else {
        console.error(res.message);
      }

    } catch (err) {
      console.error("Error cargando áreas", err);
    }
  };

  fetchAreas();
}, [authFetch]);

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center m-3">
        <h3>Crear Usuario</h3>
        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/user/user")}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {/* ALERTA GLOBAL */}
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* TIPO DE DOCUMENTO Y DOCUMENTO */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Tipo de documento *</label>
            <select
              name="type_doc"
              className="form-select"
              value={formData.type_doc}
              onChange={handleChange}
            >
              <option value="" disabled hidden>
                Selecciona...
              </option>
              <option value="CC">Cédula de ciudadanía</option>
              <option value="TI">Tarjeta de identidad</option>
              <option value="PPT">PPT</option>
              <option value="CE">Cédula de extranjería</option>
              <option value="PAS">Pasaporte</option>
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label>Documento *</label>
            <input
              type="text"
              name="IdDocumento"
              className="form-control"
              value={formData.IdDocumento}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* NOMBRES */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Primer nombre *</label>
            <input
              type="text"
              name="first_name"
              className="form-control"
              value={formData.first_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Segundo nombre</label>
            <input
              type="text"
              name="second_name"
              className="form-control"
              value={formData.second_name}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* APELLIDOS */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Primer apellido *</label>
            <input
              type="text"
              name="last_name"
              className="form-control"
              value={formData.last_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Segundo apellido</label>
            <input
              type="text"
              name="second_last_name"
              className="form-control"
              value={formData.second_last_name}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          {/* CORREO */}
          <div className="col-md-6 mb-3">
            <label>Correo electrónico *</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Área *</label>
            <select
                name="area"
                className="form-select"
                value={formData.area}
                onChange={handleChange}
              >
                <option value=""hidden>Selecciona...</option>

                {areas.map((area) => (
                  <option key={area.id_area} value={area.id_area}>
                    {area.name}
                  </option>
                ))}

              </select>
          </div>
        </div>
     

        {/* ROL */}
        <div className="mb-3">
          <label>Rol *</label>
          <select
            name="role"
            className="form-select"
            value={formData.role}
            onChange={handleChange}
          >
            <option value="" hidden>Selecciona un rol...</option>
            <option value="SuperAdmin">Super Administrador</option>
            <option value="Director General">Director General</option>
            <option value="Apoyo">Apoyo</option>
            <option value="Coordinador">Coordinador</option>
            <option value="Sst">SST</option>
            <option value="Apoyo Sst">Apoyo Sst</option>
            <option value="Empleado">Empleado</option>
            <option value="Comunicaciones">Comunicaciones</option>
          </select>
        </div>

        {/* 🔐 Contraseña por defecto, ya NO se muestra al usuario */}
        <p style={{ fontSize: "12px", color: "gray" }}>
            *La contraseña asignada será: <b>Presencia2025*</b>
        </p>

        <button type="submit" className="btn btn-outline-pink w-100">
          Crear Usuario
        </button>
      </form>
    </div>
  );
};

export default CreateUser;
